var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 29.875V28C27.125 27.0054 26.7299 26.0516 26.0267 25.3483C25.3234 24.6451 24.3696 24.25 23.375 24.25H17.75C16.7554 24.25 15.8016 24.6451 15.0983 25.3483C14.3951 26.0516 14 27.0054 14 28V29.875",
    stroke: "#007DD4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8125 16.75C16.8125 17.7446 17.2076 18.6984 17.9108 19.4017C18.6141 20.1049 19.5679 20.5 20.5625 20.5C21.5571 20.5 22.5109 20.1049 23.2142 19.4017C23.9174 18.6984 24.3125 17.7446 24.3125 16.75C24.3125 15.7554 23.9174 14.8016 23.2142 14.0983C22.5109 13.3951 21.5571 13 20.5625 13C19.5679 13 18.6141 13.3951 17.9108 14.0983C17.2076 14.8016 16.8125 15.7554 16.8125 16.75Z",
    stroke: "#007DD4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleUserIcon);
export default __webpack_public_path__ + "static/media/SingleUserIcon.dac5f5a41952c7b64df08981c9f4148a.svg";
export { ForwardRef as ReactComponent };